const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Simple performance reporting without web-vitals dependency
    console.log('Performance monitoring enabled');
  }
};

export default reportWebVitals;